module.exports = __webpack_public_path__ + "img/banner.2d928229.png";